import { createTheme } from '@mui/material/styles';
import { themeOptions } from './theme.options';

const themeBase = createTheme(themeOptions);

// Extend typography by using breakpoints
const theme = createTheme(themeBase, {
  typography: {
    h1: {
      fontSize: '20px',
      lineHeight: '26px',
      fontWeight: '700',

      [themeBase.breakpoints.up('sm')]: {
        fontSize: '24px',
        lineHeight: '30px',
      },
    },
    h2: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: '700',

      [themeBase.breakpoints.up('sm')]: {
        fontSize: '20px',
        lineHeight: '26px',
      },
    },
    h3: {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: '700',

      [themeBase.breakpoints.up('sm')]: {
        fontSize: '16px',
        lineHeight: '24px',
      },
    },
    body1: {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: '400',

      [themeBase.breakpoints.up('sm')]: {
        fontSize: '16px',
        lineHeight: '24px',
      },
    },
    body2: {
      fontSize: '12px',
      lineHeight: '18px',
      fontWeight: '400',

      [themeBase.breakpoints.up('sm')]: {
        fontSize: '14px',
        lineHeight: '20px',
      },
    },
    subtitle1: {
      fontSize: '18px',
      lineHeight: '24px',
      fontWeight: 600,
      [themeBase.breakpoints.up('sm')]: {
        fontSize: '20px',
        lineHeight: '28px',
      },
    },
    button: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: '700',
    },
    specialInfo: {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: '900',

      [themeBase.breakpoints.up('sm')]: {
        fontSize: '16px',
        lineHeight: '24px',
      },
    },
    price: {
      fontSize: '24px',
      lineHeight: '30px',
      fontWeight: '900',

      [themeBase.breakpoints.up('sm')]: {
        fontSize: '36px',
        lineHeight: '46px',
      },
    },
    displayXl: {
      fontSize: '24px',
      lineHeight: '140%',
      fontWeight: '700',

      [themeBase.breakpoints.up('sm')]: {
        fontSize: '30px',
      },
    },
  },
});

export default theme;
